import { getLogoSrc } from "./utils/cardTypeUtil";
const SAVED_CARDS = "/get-withdrawal-customer/card";

const fetchSavedCards = async (savedCardsInfo, baseUrl) => {
  try {
    const basicToken = btoa(
      `${savedCardsInfo?.APP_KEY}:${savedCardsInfo?.SECRET_KEY}`
    );
    const response = await fetch(
      `${baseUrl}${SAVED_CARDS}?merchantAccountId=${savedCardsInfo?.merchantAccountId}&customerReferenceId=${savedCardsInfo?.customerReferenceId}&email=${savedCardsInfo?.email}`,
      {
        method: "GET",
        headers: {
          Authorization: `Basic ${basicToken}`,
        },
      }
    );
    const jsonResponse = await response.json();
    return jsonResponse?.data;
  } catch (error) {
    console.error("failed to get saved card");
    return [];
  }
};

const payWithSavedCard = async (e, payload, baseUrl, onSubmit) => {
  e.stopPropagation();
  try {
    const response = await fetch(`${baseUrl}/payment/process`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      throw new Error("Payment processing failed: " + response.statusText);
    }
    const result = await response.json();
    input.value = "";
    if (onSubmit && typeof onSubmit === "function") {
      onSubmit({ status: "success", data: result });
    }
  } catch (error) {
    onSubmit({ status: "failed", data: error });
  }
};

export async function SavedCardsWithoutSession(
  containerId,
  savedCardsInfo,
  baseUrl,
  onSubmit,
  hosted_baseurl,
  styles = {}
) {
  const container = document.getElementById(containerId);
  const savedCard = await fetchSavedCards(savedCardsInfo, baseUrl);
  // Create UL
  const ul = document.createElement("ul");
  ul.classList.add("wrapper");

  savedCard.forEach((card) => {
    const li = document.createElement("li");
    li.classList.add("row-class");
    li.style.cursor = "pointer";
    // Optional li border and text color
    if (styles?.rowBorderColor)
      li.style.border = `1px solid ${styles.rowBorderColor}`;
    if (styles?.rowTextColor) li.style.color = styles.rowTextColor;

    // Wrapper for card icon and number
    const cardInfoWrapper = document.createElement("span");
    cardInfoWrapper.classList.add("card-info");

    const span = document.createElement("span");
    span.textContent = card?.masked_card;

    const img = document.createElement("img");
    img.src = getLogoSrc(card?.card_type?.toUpperCase(), hosted_baseurl);
    img.alt = "Card Icon";
    img.style.width = "25px";
    img.style.margin = "0 5px";

    cardInfoWrapper.appendChild(img);
    cardInfoWrapper.appendChild(span);

    // wrapper for cvc input and submit
    const inputButtonWrapper = document.createElement("span");
    inputButtonWrapper.classList.add("input-wrapper", "hidden");
    // optional cvc wrapper style
    if (styles?.cvcInputBorderColor) {
      inputButtonWrapper.style.border = `1px solid ${styles.cvcInputBorderColor}`;
    }

    const input = document.createElement("input");
    input.type = "password";
    input.maxLength = 4;
    input.placeholder = `Enter CVC`;
    input.classList.add("input-class");
    // Optional input text + placeholder color
    if (styles?.cvcInputTextColor) input.style.color = styles.cvcInputTextColor;
    if (styles?.cvcInputPlaceholderColor) {
      input.style.setProperty(
        "--placeholder-color",
        styles.cvcInputPlaceholderColor
      );
      input.style.setProperty("color", styles.cvcInputTextColor || "");
      input.style.cssText += `
        &::placeholder { color: ${styles.cvcInputPlaceholderColor}; }
      `;
      // fallback trick for inline placeholder styling
      input.placeholder = input.placeholder;
    }

    const button = document.createElement("button");
    button.textContent = styles?.buttonText ? styles?.buttonText : "Submit";
    button.classList.add("btn-class");
    button.disabled = true; // remain disabled by default
    // Optional button text, background and color
    if (styles?.buttonTextColor) button.style.color = styles.buttonTextColor;
    if (styles?.buttonBackground)
      button.style.background = styles.buttonBackground;

    input.addEventListener("input", () => {
      button.disabled = input.value.length < 3;
    });

    // Submit action
    button.addEventListener("click", (e) =>
      payWithSavedCard(
        e,
        {
          id: sessionID,
          existing_card_id: card?.card_uuid,
          secret: input.value,
          payUsingExistingCard: true,
        },
        baseUrl,
        onSubmit
      )
    );

    inputButtonWrapper.appendChild(input);
    inputButtonWrapper.appendChild(button);

    li.appendChild(cardInfoWrapper);
    li.appendChild(inputButtonWrapper);
    ul.appendChild(li);

    // Click on li to show this input-wrapper and hide others
    li.addEventListener("click", () => {
      ul.querySelectorAll(".input-wrapper").forEach((wrapper) => {
        if (wrapper !== inputButtonWrapper) wrapper.classList.add("hidden");
      });
      inputButtonWrapper.classList.remove("hidden"); // show this one
    });
  });

  // Append UL into the container div
  container.innerHTML = "";
  container.appendChild(ul);
}
